export const CABLE_SOLUTION = {
  server1: { A: true, B: false, C: true },
  server2: { A: false, B: true, C: true, D: false },
  serverPrincipal: {
    A: false,
    B: true,
    C: true,
    D: false,
    E: false,
    F: false,
    G: false,
    H: true,
    I: true,
  },
  server4: { A: true, B: true },
};